import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import axios from 'axios'

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    NProgress.start();
    // Do something before request is sent
    return config;
  }, function (error) {
  	NProgress.done();
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
	NProgress.done();
    // Do something with response data
    return response;
  }, function (error) {
  	NProgress.done();
    // Do something with response error
    return Promise.reject(error);
});


// WEBPACK FOOTER //
// ./src/store/nloader.js